import { FilterInfoModel } from "../security/filters-info.model";
import { PagingInfoModel } from "./paging-info-model";

export class BaseSearchModel extends PagingInfoModel {
    sortColumnDirective: string | undefined;
    sortDirectionDirective: string | undefined;
    startIndex: number = 0;
    searchTerm: string | undefined;
    filterInfo?: FilterInfoModel |undefined;
    ids?: string[];
}